module.exports = __webpack_public_path__ + "img/content-1.42728049.png";